import Cookies from "js-cookie";
// import { GlbContext as appGlbContext } from ".";
// import { GlbContext as appGlbContext } from "./App2";
import { createContext, useState, useContext, Component, useEffect, useRef } from "react";
import axios_with_token, { parseTblDef, getRcds, handleLogout, randomUUID } from "./axios_with_token";


// [] for remote
// export const rootUrl = "/wwofficenew/build";
// export const bkendUrl = "/wwofficenew";

// [] for local
// export const rootUrl = "/build";
// export const bkendUrl = "";
// export const jsonPath = "wwoffice";
// export const loginUrl = bkendUrl+'/auth/jwt_login/'+jsonPath;

export const VAL_DELETED = `DELETED_${randomUUID()}`

// // [godaddy] wwofficenew ********************
export function getRootUrl(){
  return Cookies.get('rootUrl') || "/wwofficenew/build";
}

export function getBkendUrl(){
  // return (Cookies.get('bkendUrl') || "");
  return 'https://www.willowest.com/wwofficenew/';
}
// // [godaddy] wwofficenew ********************

// [local] ***********************
// export function getRootUrl(){
//   return Cookies.get('rootUrl') || "/build";
// }

// export function getBkendUrl(){
//   return (Cookies.get('bkendUrl') || "http://localhost:5000");
//   // return "/build"
// }
// [local] ***********************

export function getJsonPath(){
  return "wwoffice";
}


// front
// export const getRootUrl = _=>Cookies.get('rootUrl') || rootUrl;
export const setRootUrl = val=>Cookies.set('rootUrl', val);

// backend
// export const getBkendUrl = _=>(Cookies.get('bkendUrl') || "");
// export const getJsonPath = _=>(Cookies.get('jsonPath') || "wwoffice");
export const getLoginUrl = _=> getBkendUrl() + '/auth/jwt_login/' + getJsonPath();



export const setBkendUrl = val=>Cookies.set('bkendUrl', val);
export const setJsonPath = val=>Cookies.set('jsonPath', val);



export const  siteMode = "edit"; //view, edit

export function getTokenName(jsonPathIn){
  return 'x-auth-token-' + ( jsonPathIn || getJsonPath() );
}




// [start]error boundary
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by Error Boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong. Please try again later.</h1>;
    }
    return this.props.children;
  }
}
// [end]error boundary

// [start]customized hook for tblDefs - replace
// [todo] tblName -> tblNames
export function useTblDefs(tblNames) {
  // [] these sets will cause parent to re-render.
  const refTblDefs = useRef({
    tblDefs: {},
    loading: false
  });

  const [tblDef, setTblDef] = useState(null);

  useEffect(_=>{
    if(!tblNames)return;
    if(!refTblDefs.current.tblDefs[tblNames]){
      refTblDefs.current.loading = true;
      if(tblNames=="users"){
        getRcds("addresses", {
          filters: {
            entity: `^1$`,
            purposes: "warehouse"
          }
        }).then(r=>{
          console.log('------------------------->', r);
          setTblDef({
              listFlds: 'username,fullName',
              inputSettings:{
                  username: {},
                  password: {},
                  fullName: {},
                  roles: { //one user may have multiple roles
                      type: 'checkboxes',
                      src: [
                          ['admin', 'admin'],
                          ['sales', 'sales'],
                          ['purchase', 'purchase'],
                          ['accounting', 'accounting'],
                          ['operating', 'operating'],
                          ['logistics', 'logistics']
                      ]
                  },
                  // rcd.logisticsInfo[0] --> if maxRcd is 1, then set and get shall be different
                  logisticsInfo: { //one user may have multiple roles
                    type:'jsonObjs',
                    // oneObj: true,
                    // caption:window._ww_tools.getLan('logisticsInfo'),
                    showFlds: 'warehouses',
                    objTpl: {
                        flds: "warehouses,initMenuPath",
                        inputSettings:{
                            // multiple select addresses
                            warehouses: {
                              type: "search",
                              multiple: true,
                              srcTbl: "addresses",
                              srcSearchFlds: 'address1,address2,city,province,country,zip',
                              srcShowFlds: 'address1,address2,city,province,country,zip',
                              // type: 'select',
                              // src: (r.rcds||[]).map(rcd=>[rcd.__id, rcd.name])
                              // type: 'searchItems',
                              // srcId: _ww_tools.getObjId(arrs.addresses),
                              // srcTbl: "addresses",
                              // showFlds: 'entity,name',
                              // srcSearchFlds: 'entity,name,address1',
                              // srcShowFlds: 'entity,name,address1',
                              // showFn:(val, rcdVal)=>{
                              //     console.log(val,rcdVal);
                              //     let tblAddr = _ww_tools.tbls.getTbl('addresses');
                              //     return `<ol style="text-align: left;">
                              //         ${
                              //             (val||'').split(',').filter(v=>v).map(addrId=>{
                              //                 let addr=tblAddr.getRcd(addrId);
                              //                 return `<li>${addr.name} (${addr.address1})</li>`;
                              //             }).join('')
                              //         }
                              //     </ol`;
                              // },
                              // // opt.showFn(val, rcdVal)
                              // allowAddNew: true
                            }
                        }
                    }
                  },
                  initMenuPath:{}
                  // additional information depending on user roles
              }
          });

        })
  
      }else {
        axios_with_token.get(
            getBkendUrl() + "/jwt/tblDef/" + getJsonPath() + "/" + tblNames
        ).then(res=>{
            if(res&&res.data.status){
                // [] clear old tblDef
                const tblDef = parseTblDef(res.data.data.tblDef);
                // const newTblDef = {};
                // newTblDef[tblNames] = tblDef;
                // setTblDefs(...tblDefs, ...newTblDef);
                refTblDefs.current.tblDefs[tblNames] = tblDef;
                setTblDef(refTblDefs.current.tblDefs[tblNames]);
                refTblDefs.current.loading = false;
            }
        }).catch(err=>{
            console.error((err||{}).message);
        });
      }
    }else{
      // trigger refresh
      setTblDef(refTblDefs.current.tblDefs[tblNames]);
    }

  }, [tblNames]);

  // [user tbl def override]

  return {
    tblDef: tblDef||{},
    loading: refTblDefs.current.loading
  };
}
// [end]customized hook for tblDefs

// [start] data provider
const GlbContext = createContext({});
// export const glbContext = GlbContext;
export const DataProvider = ({ children }) => {
  const [cartUtils, setCartUtils] = useState(null);
  const [cart, setCart] = useState({});
  const [siteData, setSiteData] = useState({});
  const [pageData, setPageData] = useState({
    currentPdtCat: null,
    currentPdt: null
  });

  const [searchFilters, setSearchFilters] = useState({});
  const [searchPage, setSearchPage] = useState(0);

  const [loggedIn, setLoggedIn] = useState(false);
  const [userInfo, setUserInfo] = useState(false);

  const { regLogoutCb } = handleLogout();

  // useEffect(_=>{
  //   regLogoutCb(_=>{
  //     setLoggedIn(false);
  //     setUserInfo(false);        
  //   })
  // },[])

  return (
    <GlbContext.Provider
      value={{
          cartUtils, setCartUtils,
          cart, setCart,
          siteData, setSiteData,
          pageData, setPageData,


          searchFilters, setSearchFilters,
          searchPage, setSearchPage,

          loggedIn, setLoggedIn,
          userInfo, setUserInfo

      }}
    >

        {/* <ModalRcdEdit
            mode={mode}
            showMode={showMode}
            setShowMode={setShowMode}

            tblName={tblName}
            rcdId={rcdId}
        /> */}
      
      {children}
    </GlbContext.Provider>
  );
};

export const useData = ()=>useContext(GlbContext);
// [end] data provider

// [start] get tbl List
// [ ] async funciton version


export const getTblList = async ()=>{
  return new Promise((res,rej)=>{
      res(axios_with_token(
          getBkendUrl() + '/jwt/tblInfo/' + getJsonPath(), 
          {
              method: "get",
              withCredentials: true,
              headers: {
                  'Content-Type': 'application/json'
              }
          }
      ).then(res=>{
          if(res&&res.data.status){
              return res.data.data.tblInfo;
          }
      }).catch(err=>{
          console.log(err);
      }));

  });

}

// // [use... version]
// // [] input_types are filled into tpl using render, which may cause mount/unmount and reinit the data
// // [-] , which means hooks used in tpl will mount/unmount during rerender.
// // [-] use... hook's useRef data could only persist during mount / unmount.
// const useTblListCache = {
//   tblList: false,
//   loading: false
// };
// // export function useTblList() {
// //   const refTblList = useRef(useTblListCache);

// //   const [tblList, setTblList] = useState(null);
// //   const [loading, setLoading] = useState(false); // Make loading reactive

// //   const {loggedIn} = useData();

// //   // [trace mount/unmount]
// //   useEffect(() => {
// //     console.log('.............useTblList mounted');

// //     // Unmount
// //     return () => {
// //         console.log('..................useTblList unmounted');
// //     };
// //   }, []); // Empty dependency array means this runs only on mount and unmount

// //   // [] get tbl list 
// //   useEffect(() => {
// //     // Only fetch data if tblList is not already loaded and not currently loading
// //     if (loggedIn && !refTblList.current.tblList && !refTblList.current.loading) {
// //       refTblList.current.loading = true;
// //       setLoading(true); // Update reactive loading state

// //       console.log('loading tbl list remotely...');
// //       axios_with_token(
// //         `${bkendUrl}/jwt/tblInfo/${jsonPath}`,
// //         {
// //           method: "get",
// //           withCredentials: true,
// //           headers: {
// //             'Content-Type': 'application/json'
// //           }
// //         }
// //       ).then(res => {
// //         console.log('refTblList.current res:', res);
// //         if (res && res.data.status) {
// //           refTblList.current.tblList = res.data.data.tblInfo;
// //           setTblList(refTblList.current.tblList); // Update state to trigger re-render
// //         }
// //       }).catch(err => {
// //         console.log(err);
// //       }).finally(() => {
// //         refTblList.current.loading = false;
// //         setLoading(false); // Update reactive loading state
// //       });
// //     }
// //   }, [loggedIn]); // Add jsonPath as a dependency to re-fetch if it changes

// //   return {
// //     tblList: refTblList.current.tblList,
// //     loading: refTblList.current.loading // Return reactive loading state
// //   };
// // }

// // [end] get tbl List

// for rest backend settings
const REWWWURL = /^(http:\/\/|https:\/\/)/;
export const getUploadFileUrl=(fileUrl)=>{
  if(REWWWURL.test(fileUrl)){
    return fileUrl;
  }

  const pattern = /^\/*(?:static\/uploads\/|uploads\/)/;
    
  // Replace the matched prefix with an empty string
  return `${getBkendUrl()}/static/uploads/${fileUrl.replace(/\\/g, '/').replace(pattern, '')}`;

  // [] option 2
  //   const splitedUrl = (fileUrl||'').split(/[\\|/]/);
  //   return `${bkendUrl}/static/uploads/${splitedUrl.pop()}`.replace(/\\/g, '/');
}

export const getUploadThumbUrl=(fileUrl)=>{
    // return `${bkendUrl}/static/${fileUrl}`.replace(/\\/g, '/').replace('/uploads/', '/uploads/thumbnails/');
    if(REWWWURL.test(fileUrl)){
      return fileUrl;
    }
    return `${getBkendUrl()}/jwt/thumbnail/${fileUrl}`.replace(/\\/g, '/');
}

export const getRandomInArray=(arr=>{
    if(!arr || arr.constructor!==Array || arr.length<1){
        return false;
    }

    return arr[Math.floor(Math.random()*(arr.length+1))];
});

// 设置cookie
export function setCookie (c_name, value, expiremMinutes) {
    const exdate = new Date();
    exdate.setTime(exdate.getTime() + expiremMinutes * 60 * 1000);
    // https://stackoverflow.com/questions/26342123/replacement-for-javascript-escape
    document.cookie = c_name + '=' + encodeURIComponent(value) + ((expiremMinutes == null) ? '' : ';expires=' + exdate.toGMTString());
}
// 读取cookie
export function getCookie (c_name) {
    if (document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(c_name + '=');
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        let c_end = document.cookie.indexOf(';', c_start);
        if (c_end == -1) {c_end = document.cookie.length}
        return decodeURIComponent(document.cookie.substring(c_start, c_end))
      }
    }
    return '';
}
// 删除cookie
export function delCookie (c_name) {
    const exp = new Date();
    exp.setTime(exp.getTime() - 1);
    const cval = getCookie(c_name);
    // if (cval != null) {
        document.cookie = c_name + '=' + cval + ';expires=' + exp.toGMTString();
    // }
}


export const imgs = [
    "https://www.ritzcarltonshops.com/images/products/lrg/the-ritz-carlton-hotel-stripe-linen-set-RTZ-1240-LS-01_lrg.jpg",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPH0vVKL8zu9YGgeCBvYocxEaW1GwoZy_dnw&s",
    "https://www.wilkinslinen.com/website/wp-content/uploads/2018/10/hospitality-tips-and-tricks-1000x675.jpg",
    "https://www.housecustomize.com/wp-content/uploads/2023/08/modern-hotel-lobby-furniture.jpg",
    "https://www.midj.com/images/uploads/blog/01-arredo-hotel-midj.jpg",
    "https://www.midj.com/images/uploads/blog/05-arredo-hotel-pouf-poltrona.jpg",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSwlSvAxBqvnjBMPlnTEuaZ7W8Q7X1PPNES_Q&s",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRn4hMUrr-sffwBUZadba2awRZIX4KznLg6DA&s"
  
  ];

  export function getRandomImg(){
    return imgs[Math.floor(imgs.length*Math.random())];
  }
  

  